// Header.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';
import { FaBars } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Header = ({ toggleSidebar }) => {
  const { t } = useTranslation('sidebar');
  const [title, setTitle] = useState('');
  const location = useLocation();

  // map routes → translation keys
  const pathToKey = {
    '/overview': 'sidebar.header.dashboard',
    '/manage-services': 'sidebar.header.services',
    '/manage-staff': 'sidebar.header.staff',
    '/calendar': 'sidebar.header.calendar',
    '/roster': 'sidebar.header.roster',
    '/support': 'sidebar.header.support',
    '/payments': 'sidebar.header.payments',
    '/manage-site': 'sidebar.header.manageSite',
    '/online-booking': 'sidebar.header.manageOnlineBookings',
    '/settings': 'sidebar.header.settings',
    '/search': 'sidebar.header.search'
  };

  useEffect(() => {
    const key = pathToKey[location.pathname] || 'sidebar.header.fallback';
    setTitle(t(key));
  }, [location.pathname, t]); // re-run on route or language change

  return (
    <header className="app-header">
      <div className="header-left">
        <button id="hamburger-toggle" className="hamburger-btn" onClick={toggleSidebar}>
          <FaBars className="testings" />
        </button>
        <span className="header-title">{title}</span>
      </div>
      <div className="header-right">
        {/* Optional space for avatar, buttons, etc. */}
      </div>
    </header>
  );
};

export default Header;
